import type {
  GatorProtectActiveProModalButtonLabel,
  GatorProtectActiveProModalLocale,
} from '../../gatorProtect.types';
import type { ActiveProModalMonthly } from './ActiveProModal.types';

export type ActiveProModalResolvedCopy = Partial<GatorProtectActiveProModalLocale> & {
  buttonLabel: GatorProtectActiveProModalButtonLabel;
};

export const getActiveProModalCopy = (
  modalLocale: Partial<GatorProtectActiveProModalLocale> | undefined,
  isTurbo: boolean,
): ActiveProModalResolvedCopy | null => {
  if (!modalLocale) {
    return null;
  }

  if (isTurbo && modalLocale.turbo) {
    const { turbo } = modalLocale;
    return {
      ...modalLocale,
      title: turbo.title ?? modalLocale.title ?? '',
      subtitle: turbo.subtitle ?? modalLocale.subtitle ?? '',
      checklistItems: turbo.checklistItems ?? modalLocale.checklistItems ?? [],
      termsPrefix: turbo.termsPrefix ?? modalLocale.termsPrefix ?? '',
      termsLink: turbo.termsLink ?? modalLocale.termsLink ?? '',
      buttonLabel: turbo.buttonLabel ?? modalLocale.buttonLabel ?? '',
    };
  }

  return modalLocale as ActiveProModalResolvedCopy;
};

export const resolveActiveProButtonLabel = (
  copy: Pick<ActiveProModalResolvedCopy, 'buttonLabel'>,
  monthly?: ActiveProModalMonthly,
): string => {
  if (typeof copy.buttonLabel === 'function') {
    return copy.buttonLabel(monthly?.formattedPrice ?? '...');
  }
  return copy.buttonLabel;
};
